import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { EMPTY_CART } from '../../constants/cartConstants';

const CashfreeCallback = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        const cashfreeOrderId = searchParams.get('order_id');
        console.log('Cashfree Order ID from params:', cashfreeOrderId);
        
        if (!cashfreeOrderId) {
            console.log('No order_id in params, navigating to orders');
            navigate('/orders', { replace: true });
            return;
        }

        let isMounted = true;
        let timeoutId;

        const fetchPaymentStatus = async () => {
            try {
                console.log('Fetching payment status for:', cashfreeOrderId);
                
                // Set timeout after 10 seconds
                timeoutId = setTimeout(() => {
                    if (isMounted) {
                        console.error('Callback API timeout');
                        enqueueSnackbar('Taking longer than expected, redirecting...', { variant: 'warning' });
                        navigate('/orders', { replace: true });
                    }
                }, 10000);

                const response = await axios.get(`/api/v1/cashfree/callback?order_id=${cashfreeOrderId}`, {
                    timeout: 8000
                });

                if (!isMounted) return;

                clearTimeout(timeoutId);
                console.log('Callback response:', response.data);

                if (response.data.orderId) {
                    // Clear cart on successful payment
                    if (response.data.success) {
                        dispatch({ type: EMPTY_CART });
                        enqueueSnackbar('Order placed successfully!', { variant: 'success' });
                    }
                    console.log('Navigating to order page:', response.data.orderId);
                    navigate(`/order_details/${response.data.orderId}`, { replace: true });
                } else {
                    console.warn('No orderId in response');
                    enqueueSnackbar('Order not found', { variant: 'error' });
                    navigate('/orders', { replace: true });
                }
            } catch (error) {
                if (!isMounted) return;
                
                clearTimeout(timeoutId);
                console.error('Callback error:', error);
                
                // Still try to navigate to orders as fallback
                enqueueSnackbar('Redirecting you to orders...', { variant: 'info' });
                navigate('/orders', { replace: true });
            }
        };

        fetchPaymentStatus();

        return () => {
            isMounted = false;
            clearTimeout(timeoutId);
        };
    }, [searchParams, navigate, enqueueSnackbar]);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            fontSize: '18px',
            color: '#666'
        }}>
            Processing payment...
        </div>
    );
};

export default CashfreeCallback;